import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    latestLatency: {},
    p9999Data: [],
    p999Data: [],
    p99Data: [],
    p95Data: [],
    p50Data: [],
    timeWindow: 60
};
const latencySlice = createSlice({
    name: "latency",
    initialState,
    reducers: {
        setLatestLatency (state, action) {
            state.latestLatency = action.payload;
        },
        setTimeWindow (state, action) {
            state.timeWindow = action.payload;
        },
        setHistoricalData (state, action) {
            const { key, data } = action.payload;
            state[key] = data;
        },
        addLatencyDataPoint (state) {
            const { p9999, p999, p99, p95, p50 } = state.latestLatency;
            const now = new Date().getTime();
            const oldestPoint = now - state.timeWindow * 60 * 1000;
            const cutoff = new Date(oldestPoint).getTime();
            const updateData = (arr, val)=>{
                const filtered = arr.filter((d)=>d.x >= cutoff);
                if (val != null) {
                    return [
                        ...filtered,
                        {
                            x: now,
                            y: val
                        }
                    ];
                } else {
                    return filtered;
                }
            };
            state.p9999Data = updateData(state.p9999Data, p9999);
            state.p999Data = updateData(state.p999Data, p999);
            state.p99Data = updateData(state.p99Data, p99);
            state.p95Data = updateData(state.p95Data, p95);
            state.p50Data = updateData(state.p50Data, p50);
        }
    }
});
export const { setLatestLatency, setTimeWindow, setHistoricalData, addLatencyDataPoint } = latencySlice.actions;
export default latencySlice.reducer;
